export default defineNuxtRouteMiddleware((_, from) => {
  const generalStore = useGeneralStore();
  const localePath = useLocalePathPolyfill();
  if (!generalStore.isAuthenticated) {
    return navigateTo(
      localePath({
        path: "/sign-in",
        query: {
          redirect: localePath(from),
        },
      }),
    );
  }
});
